import { useResponsiveValue } from "../../styling";
import { Box } from "../../box";
import { forwardRef } from "react";
import { isNil, mergeProps, omitProps } from "../../shared";
import { useFormContext } from "../../form";
import { jsx as _jsx } from "react/jsx-runtime";
export function useFlexAlignment({
  alignX,
  alignY,
  orientation
}) {
  return orientation === "horizontal" ? {
    alignItems: alignY,
    direction: "row",
    justifyContent: alignX
  } : {
    alignItems: alignX,
    direction: "column",
    justifyContent: alignY
  };
}
const DefaultElement = "div";
export function InnerFlex(props) {
  const [formProps, isInFormContext] = useFormContext();
  const {
    alignItems,
    as = DefaultElement,
    children,
    direction = "row",
    fluid,
    forwardedRef,
    grow,
    height,
    inline,
    justifyContent,
    reverse,
    shrink,
    width,
    wrap,
    ...rest
  } = mergeProps( // Defaults when a Flex is used in a form. These defaults are placed before "props" to ensure they have precedence.
  isInFormContext ? {
    gap: 4,
    wrap: false
  } : {}, props, omitProps(formProps, ["disabled"]));
  const alignItemsValue = useResponsiveValue(alignItems);
  const directionValue = useResponsiveValue(direction);
  const fluidValue = useResponsiveValue(fluid);
  const justifyContentValue = useResponsiveValue(justifyContent);
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      // Normalize values until Chrome support `start` & `end`, https://developer.mozilla.org/en-US/docs/Web/CSS/align-items.
      alignItems: alignItemsValue && alignItemsValue.replace("start", "flex-start").replace("end", "flex-end"),
      as,
      display: inline ? "inline-flex" : "flex",
      flexDirection: directionValue ? `${directionValue}${reverse ? "-reverse" : ""}` : undefined,
      flexGrow: grow,
      flexShrink: shrink,
      flexWrap: wrap,
      height: !isNil(height) ? height : fluidValue && directionValue === "column" ? "100%" : undefined,
      justifyContent: justifyContentValue && justifyContentValue.replace("start", "flex-start").replace("end", "flex-end"),
      ref: forwardedRef,
      width: !isNil(width) ? width : fluidValue && directionValue === "row" ? "100%" : undefined
    }),
    children: children
  });
}
InnerFlex.defaultElement = DefaultElement;
export const Flex = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerFlex, { ...props,
  forwardedRef: ref
}));